import {
  Annotation,
  Axis,
  Chart,
  Coordinate,
  G2,
  getTheme,
  Interaction,
  Interval,
  Legend,
  Line,
  Point,
  Tooltip,
} from 'bizcharts';
import { IEvent } from 'bizcharts/lib/interface';
import { useEffect } from 'react';
import { ChartByProdAmountPriceDataType } from '../../api/apiConfig';
import { useProdAmountPriceChart } from './provider/ProdAmountPriceChartProvider';
import { colorPalettes } from './colorPalette';

export const ChartByProdAmountPrice = () => {
  const { data } = useProdAmountPriceChart();

  const totalPercent = data.reduce((acc, value) => acc + value.percent, 0);

  // sortedData를 percent 내림차순으로 정렬
  const sortedData = [...data].sort((a, b) => b.percent - a.percent);

  let accumulatedPercent = 0;
  const result: ChartByProdAmountPriceDataType[] = [];
  let otherPercent = 0;

  for (let i = 0; i < sortedData.length; i++) {
    const currentItem = sortedData[i];
    accumulatedPercent += currentItem.percent;

    if (accumulatedPercent <= totalPercent * 0.8) {
      result.push(currentItem);
    } else {
      // 75%를 초과하면 나머지 항목들은 '기타' 항목으로 합침
      otherPercent += currentItem.percent;
    }
  }

  // '기타' 항목 추가
  if (otherPercent > 0) {
    result.push({ prodCd: '', prodDes: '기타', percent: otherPercent });
  }

  let chartIns: G2.Chart | null = null;
  const scale = {
    // percent: {
    //   min: 0,
    //   tickCount: 4,
    //   alias: '총 수량',
    //   type: 'linear-strict',
    //   formatter: (d: number) => `${d.toLocaleString()}개`, // 금액 포맷팅 (1000 단위 쉼표 추가 및 '원' 추가)
    // },
  };

  const colors = ['#699bff', '#fd6666'];

  return (
    result.length > 0 && (
      <div>
        <Chart
          scale={scale}
          autoFit
          height={400}
          data={result}
          onGetG2Instance={(chart: G2.Chart) => {
            chartIns = chart;
          }}
        >
          <Coordinate type='theta' radius={0.75} />
          <Tooltip showTitle={false} />
          <Legend
            position='right'
            itemName={{
              style: (item) => {
                return { fill: item.name == 'Tokyo' ? colors[0] : colors[1] };
              },
            }}
          />
          <Axis visible={false} />
          <Interval
            position='percent'
            adjust='stack'
            color={['prodDes', colorPalettes[0]]}
            style={{
              lineWidth: 1,
              stroke: '#fff',
            }}
            label={[
              'prodDes',
              {
                // label 太长自动截断
                layout: { type: 'limit-in-plot', cfg: { action: 'ellipsis' } },
                content: (data) => {
                  return `${data.prodDes}`;
                },
              },
            ]}
            state={{
              selected: {
                style: (t) => {
                  const res =
                    getTheme().geometries.interval.rect.selected.style(t);
                  return { ...res, fill: 'red' };
                },
              },
            }}
          />
          <Interaction type='element-single-selected' />
        </Chart>
      </div>
    )
  );
};
